import { Client } from './client';
import { setClient } from './decorators';
import { ClientConfig, LogLevel } from './types';

export const VERSION = '0.1.0';

let globalClient: Client | null = null;

export function init(config: ClientConfig = {}): Client {
  globalClient = new Client(config);
  setClient(globalClient);
  return globalClient;
}

export function resetGlobalClient(): void {
  globalClient = null;
  setClient(null as any);
}

export function getClient(): Client {
  if (!globalClient) {
    throw new Error('Velatir client is not initialized. Call velatir.init() first.');
  }
  return globalClient;
}

export function configureLogging(level: LogLevel | number): void {
  const client = getClient();
  init({
    apiKey: client['apiKey'],
    baseUrl: client['baseUrl'],
    timeout: client['timeout'],
    logLevel: level,
    maxRetries: client['maxRetries'],
    retryBackoff: client['retryBackoff'],
  });
}

// Re-export everything
export { watch } from './decorators';
export { Client } from './client';
export { LogLevel } from './types';
export {
  VelatirError,
  VelatirAPIError,
  VelatirTimeoutError,
  VelatirWatchDeniedError,
} from './exceptions';
export { VelatirResponse } from './models';
export type {
  ClientConfig,
  WatchOptions,
  VelatirResponse as IVelatirResponse,
} from './types';